import React from "react";
import { FaFingerprint } from "react-icons/fa";
import { Tab, Nav } from "react-bootstrap";
import { BsFillPlayFill, BsPauseFill } from "react-icons/bs";
import { useRef, useState } from "react";
import ButtonList from "../ButtonList/ButtonList";
import { Link } from "react-router-dom";

function OurServices() {

    const playerRefs = useRef([]);
    const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);

    const handlePlay = (index) => {
        if (currentPlayingIndex !== null) {
            // Pause the currently playing video
            pauseVideo(currentPlayingIndex);
        }

        playVideo(index);
    };

    const playVideo = (index) => {
        const player = playerRefs.current[index];
        if (player) {
            player.contentWindow.postMessage(
                JSON.stringify({
                    method: 'play',
                    value: null
                }),
                '*'
            );

            setCurrentPlayingIndex(index);
        }
    };

    const pauseVideo = (index) => {
        const player = playerRefs.current[index];
        if (player) {
            player.contentWindow.postMessage(
                JSON.stringify({
                    method: 'pause',
                    value: null
                }),
                '*'
            );

            setCurrentPlayingIndex(null);
        }
    };


    const videos = [
        {
            src: 'https://player.vimeo.com/video/844417814?h=b2407d1914&badge=0&autopause=0&player_id=0&app_id=58479&controls=1',
            title: 'Club Fitting',
            subtitle: 'Equipment',
            description: 'One on one time with a Certified Fitter who has all the tech and equipment options needed to find your optimal set up.'
        },
        {
            src: 'https://player.vimeo.com/video/844426147?h=b2407d1914&badge=0&autopause=0&player_id=0&app_id=58479&controls=1',
            title: 'Golf Lessons',
            subtitle: 'Instruction',
            description: 'We maximize your game. Coaching and instruction isn\'t always technique. We look at all facets to create your plan.'
        }
    ];

    return (
        <>
            <section id="our_process" className="our_process bg_dark page-section bg_img">
                <div className="container-xl">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <h2 className="sec_title">What We Do:</h2>
                        <div className="btn-section hide_mobile">
                            <ButtonList subject = "about us" />
                        </div>
                    </div>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Nav variant="pills" className="nav nav-tabs process_tabs our_services_tabs hide_desktop">
                            <Nav.Item className="">
                                <Nav.Link eventKey="first" className="">
                                    Club Fitting
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="">
                                <Nav.Link eventKey="second" className="">
                                    Golf Clubs
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <>
                            <Tab.Content className="row" id="Process_tab_Content">
                                <Tab.Pane eventKey="first" className="tab-pane fade show_desktop col-lg-6">
                                    <div className="pr_card card-radius card-dark bg_dark_black">
                                        <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                                            <div id="player" className="v-video">
                                                <iframe
                                                    ref={(el) => (playerRefs.current[0] = el)}
                                                    src="https://player.vimeo.com/video/844417814?h=b2407d1914&badge=0&autopause=0&player_id=0&app_id=58479&controls=1"
                                                    frameborder="0"
                                                    allow="autoplay; fullscreen; picture-in-picture"
                                                    allowfullscreen=""
                                                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                    title=""
                                                    data-ready="true"
                                                ></iframe>
                                            </div>
                                        </div>
                                        <div className="pr_content mb-0">
                                            <div className="gs_b d-flex align-items-center justify-content-between px-0 mb-3">
                                                <div className="gab_title">
                                                    <div className="gab_text">
                                                        <h5>Club Fitting</h5>
                                                        <small>Equipment</small>
                                                    </div>
                                                </div>
                                                <Link to="/club-fitting" className="gab_action btn btn_default bg-white text-dark">Learn More</Link>
                                            </div>
                                            <p className="mb-0">One on one time with a Certified Fitter who has all the tech and equipment options needed to find your optimal set up.</p>
                                        </div>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="second" className="tab-pane fade show_desktop col-lg-6">
                                    <div className="" role="tabpane2" aria-labelledby="second-tab">
                                        <div className="pr_card card-radius card-dark bg_dark_black">
                                            <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                                                <div id="player" className="v-video">
                                                    <iframe
                                                        ref={(el) => (playerRefs.current[1] = el)}
                                                        src="https://player.vimeo.com/video/897992575?h=b2407d1914&badge=0&autopause=0&player_id=0&app_id=58479&controls=1"
                                                        frameborder="0"
                                                        allow="autoplay; fullscreen; picture-in-picture"
                                                        allowfullscreen=""
                                                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                        title=""
                                                        data-ready="true"
                                                    ></iframe>
                                                </div>
                                            </div>
                                            <div className="pr_content mb-0">
                                                <div className="gs_b d-flex align-items-center justify-content-between px-0 mb-3">
                                                    <div className="gab_title">
                                                        <div className="gab_text">
                                                            <h5>Golf Clubs</h5>
                                                            <small>Equipment</small>
                                                        </div>
                                                    </div>
                                                    <Link to="/golf-clubs" className="gab_action btn btn_default bg-white text-dark">Learn More</Link>
                                                </div>
                                                <p className="mb-0">Our golf clubs were created out of a necessity, not to make a profit. We saw a void and took it upon ourselves to fix it.</p>
                                            </div>
                                        </div>
                                    </div>
                                </Tab.Pane>
                            </Tab.Content>
                        </>
                    </Tab.Container>
                    <div className="btn-section hide_desktop-v2 mt-5">
                        <ButtonList subject = "about us" />
                    </div>
                </div>
            </section>

        </>
    );
}

export default OurServices;